import { Connection } from "@heydex/client-runtime/connection";
import { ShellSnapshotLoader } from "@heydex/client-runtime/state/shell";
import {
  BoundedThreadSnapshotLoader,
  ThreadHistoryController,
} from "@heydex/client-runtime/state/threads";
import * as Layer from "effect/Layer";
import * as Effect from "effect/Effect";
import { Atom } from "effect/reactivity";

import * as Runtime from "../lib/runtime";
import * as ConnectionPlatform from "./platform";
import { takeBootShellSnapshot } from "../environments/primary/boot";

const layerProvidedConnectionPlatform = ConnectionPlatform.layer.pipe(Layer.provide(Runtime.layer));

const layerBootShellSnapshot = Layer.effect(
  ShellSnapshotLoader.ShellSnapshotLoader,
  Effect.map(ShellSnapshotLoader.ShellSnapshotLoader, (live) => ({
    load: (prepared) => takeBootShellSnapshot(prepared) ?? live.load(prepared),
  })),
).pipe(Layer.provide(ShellSnapshotLoader.layer));

const layerSnapshotLoader = Layer.mergeAll(
  BoundedThreadSnapshotLoader.layer,
  layerBootShellSnapshot,
  ThreadHistoryController.layer,
);

type ConnectionLayerSource =
  | ReturnType<typeof Connection.layer>
  | typeof layerSnapshotLoader
  | typeof Runtime.layer
  | typeof ConnectionPlatform.layer;

const layerProvidedClientConnection = layerSnapshotLoader.pipe(
  Layer.provideMerge(Connection.layer()),
  Layer.provideMerge(Layer.mergeAll(Runtime.layer, layerProvidedConnectionPlatform)),
);

const layerConnection = layerProvidedClientConnection;

export const connectionAtomRuntime: Atom.AtomRuntime<
  Layer.Success<ConnectionLayerSource>,
  Layer.Error<ConnectionLayerSource>
> = Atom.runtime(layerConnection);
